export class LoadNews {
    static readonly type = '[News] Load news';

    constructor(public payload: { lang: string }) {}
}
